export default defineNuxtPlugin((nuxtApp) => {
   let registration: Promise<void> | null = null

   const loadAgGrid = () => {
      registration ??= Promise.all([import('ag-grid-community'), import('ag-grid-vue3')]).then(
         ([{ AllCommunityModule, ModuleRegistry }, { AgGridVue }]) => {
            ModuleRegistry.registerModules([AllCommunityModule])
            nuxtApp.vueApp.component('AgGridVue', AgGridVue)
         }
      )
      return registration
   }

   return { provide: { loadAgGrid } }
})
